import Image, { ImageProps } from 'next/image';

type Source = {
  media: string; // e.g. "(max-width: 768px)"
  srcSet: string; // mobile image URL
  blurDataURL?: string;
};

type ResponsiveImageProps = {
  alt: string;
  fallbackSrc: string; // default image URL
  fallbackBlurDataURL?: string;
  sources: Source[]; // array of media queries and srcSets
  imageProps?: Partial<Omit<ImageProps, 'src' | 'alt'>>;
};

export const ResponsiveImage = ({
  alt,
  fallbackSrc,
  fallbackBlurDataURL,
  sources,
  imageProps,
}: ResponsiveImageProps) => {
  return (
    <picture>
      {sources.map((source, idx) => (
        <source key={idx} media={source.media} srcSet={source.srcSet} />
      ))}
      <Image
        src={fallbackSrc}
        alt={alt}
        fill
        style={{ objectFit: 'cover' }}
        placeholder={fallbackBlurDataURL ? 'blur' : 'empty'}
        blurDataURL={fallbackBlurDataURL}
        priority={imageProps?.priority}
        className={imageProps?.className || ''}
        {...imageProps}
      />
    </picture>
  );
};
